const UPDATE_VIDEO = (state, payload) => {
  state.video = payload
}

const UPDATE_REALTIME_VIDEO = (state, payload) => {
  state.video.config.realtimeAnalytics = payload
}

const UPDATE_VIDEO_CONFIG = (state, payload) => {
  state.video.config = payload
}

const UPDATE_AUDIO_LIST = (state, payload) => {
  state.video.audios = payload
  state.video = { ...state.video }
}

const UPDATE_VIDEO_PROFILE = (state, payload) => {
  state.profile = payload
}

const UPDATE_PLAYER = (state, payload) => {
  state.player = payload
}

const UPDATE_VIDEO_PROFILE_ID = (state, payload) => {
  state.profile_id = payload
}

const UPDATE_STATUS_ERROR = (state, payload) => {
  state.internalError = payload
}

const UPDATE_VSL_FB = (state, payload) => {
  state.profile.vsl.fbPixel = payload
}

const UPDATE_VSL_GOOGLE = (state, payload) => {
  state.profile.vsl.gtagIds = payload
}

const UPDATE_VIDEO_SUBTITLES = (state, payload) => {
  state.video.config.subtitles = payload
}

const RESET_SUBTITLE_DATA = (state) => {
  state.subtitleData.upload = {
    subtitleListToBeUploaded: [],
    subtitleToBeUploaded: null,
  }
}

const UPDATE_GENERATING_SUBTITLE_DATA = (state, payload) => {
  state.subtitleData.fetching = payload
}

const UPDATE_GENERATING_DUBBING_DATA = (state, payload) => {
  state.dubbingData.fetching = payload
}

const UPDATE_VIDEO_ORIGINAL_LANG = (state, payload) => {
  state.video.original_lang = payload
}

const RESET_DUBBING_DATA = (state) => {
  state.dubbingData.upload = {
    dubbingListToBeUploaded: [],
    dubbingToBeUploaded: null,
  }
}

const UPDATE_AI_WORKFLOW_DATA = (state, payload) => {
  state.aiWorkFlow.data = payload
}
const UPDATE_AI_WORKFLOW_STATUS = (state, payload) => {
  state.aiWorkFlow.status = payload
}
const UPDATE_AI_WORKFLOW = (state, payload) => {
  state.aiWorkFlow.isEnabled = payload
}
const UPDATE_PANDA_AI = (state, { key, value }) => {
  state.panda_ai[key] = value
}
const UPDATE_SMART_SEARCH = (state, payload) => {
  state.smartSearch = payload
}
const UPDATE_VIDEO_CONFIG_CTAS = (state, payload) => {
  state.video.config.ctas = payload
}

export {
  UPDATE_VIDEO,
  UPDATE_REALTIME_VIDEO,
  UPDATE_VIDEO_PROFILE,
  UPDATE_VIDEO_PROFILE_ID,
  UPDATE_PLAYER,
  UPDATE_STATUS_ERROR,
  UPDATE_VSL_FB,
  UPDATE_VSL_GOOGLE,
  RESET_SUBTITLE_DATA,
  RESET_DUBBING_DATA,
  UPDATE_AUDIO_LIST,
  UPDATE_GENERATING_SUBTITLE_DATA,
  UPDATE_GENERATING_DUBBING_DATA,
  UPDATE_VIDEO_SUBTITLES,
  UPDATE_VIDEO_ORIGINAL_LANG,
  UPDATE_AI_WORKFLOW_DATA,
  UPDATE_AI_WORKFLOW_STATUS,
  UPDATE_AI_WORKFLOW,
  UPDATE_SMART_SEARCH,
  UPDATE_VIDEO_CONFIG,
  UPDATE_VIDEO_CONFIG_CTAS,
  UPDATE_PANDA_AI,
}
